import './Section.scss';

export { default } from './Section';
